import { Select, TextField } from '@automata/ui';
import { logger } from '@automata/utils';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import startCase from 'lodash/startCase';
import React from 'react';

import type { LabwareFieldsProps } from './LabwareFields';
import { LABWARE_CONTENT_LIST } from '../../../constants';
import type { LabwareProperties } from '../../../types';

interface ContentFieldProps {
  content: LabwareProperties['content'];
  contentDescription: LabwareProperties['contentDescription'];
  updateFields: LabwareFieldsProps['handlePendingChange'];
}

export const ContentField = ({
  content,
  contentDescription,
  updateFields,
}: ContentFieldProps) => {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Stack gap={1} flex={3}>
        <FormControl>
          <Select
            label="Content"
            value={content}
            onChange={(e) => {
              const value = e.target.value;
              if (typeof value === 'string' || value === undefined) {
                updateFields({ content: value });
              } else {
                logger.error('ContentField: unexpected value type for:', value);
              }
            }}
            fullWidth
          >
            {LABWARE_CONTENT_LIST.map((v) => (
              <MenuItem key={v} value={v}>
                {startCase(v)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {content !== 'empty' && (
          <TextField
            label="Content Description (Optional)"
            value={contentDescription || ''}
            onChange={(e) =>
              updateFields({ contentDescription: e.target.value })
            }
          />
        )}
      </Stack>
    </Stack>
  );
};
